export const ITS_ONLINE = 'ITS_ONLINE';

export const MAIN_TABLE = 'MAIN_TABLE';
